<template>
  <div class="multiselect-wrapper" :class="{ telao: telao, 'has-clear': hasValue && allowEmpty && clearable }">
    <multiselect
      :value="value"
      @input="changeItem"
      @open="handleFocus"
      @close="handleBlur"
      selectLabel=""
      selectGroupLabel="Selecionar Grupo"
      selectedLabel=""
      :deselectLabel="deselectLabel"
      deselectGroupLabel="Retirar Seleção do Grupo"
      :allowEmpty="allowEmpty"
      :searchable="searchable"
      v-bind="config"
      @tag="addTag"
      :class="{
        telao: telao,
		clearable: clearable
      }"
    >
      <template slot="option" slot-scope="{ option }">
        <slot name="option" :option="option"></slot>
      </template>
      <template #noOptions>
        <slot name="noOptions">
          Nada por aqui
        </slot>
      </template>
      <template #noResult>
        <slot name="noResult">
          Nenhum resultado encontrado
        </slot>
      </template>

      <template #caret>
        <div class="multiselect__select">
          <i role="presentation" class="open-indicator"></i>
        </div>
      </template>
    </multiselect>
    <div 
      v-if="hasValue && allowEmpty && clearable && !isFocused" 
      class="multiselect__clear" 
      @click.prevent.stop="clearValue"
      :title="deselectLabel"
    >
      <i class="multiselect__clear-icon">×</i>
    </div>
  </div>
</template>

<script>
// Documentação do componente
// https://vue-multiselect.js.org/#sub-getting-started

import Multiselect from 'vue-multiselect'

export default {
  name: 'MultiSelect',
  components: {
    Multiselect,
  },
  data() {
    return {
      isFocused: false,
    };
  },
  props: {
    value: {},
    config: {
      type: Object,
      default: () => {}
    },
    telao: {
      type: Boolean,
      default: false,
    },
	searchable: {
      type: Boolean,
      default: true,
    },
	deselectLabel: {
      type: String,
      default: 'X',
    },
    allowEmpty: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasValue() {
      if (this.value === null || this.value === undefined) {
        return false;
      }
      if (Array.isArray(this.value)) {
        return this.value.length > 0;
      }
      if (typeof this.value === 'object') {
        return Object.keys(this.value).length > 0;
      }
      return this.value !== '' && this.value !== false;
    }
  },
  methods: {
    addTag(newTag) {
      this.$emit('tag', newTag);
    },
    changeItem(value) {
      this.$emit('input', value);
      this.$emit('change', value);
      this.$emit('blur', value);
    },
    clearValue() {
	  this.$emit('clear', null);
      this.changeItem(null);
    },
    handleFocus() {
      this.isFocused = true;
    },
    handleBlur() {
      this.isFocused = false;
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__content-wrapper {
  overflow-x: hidden;
  border: 1px solid rgba(0, 0, 0, .26) !important;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, .15) !important;
}

.multiselect,
.multiselect__input,
.multiselect__single {
  font-size: inherit !important;
}

.multiselect__select {
  z-index: 2;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 30px !important;
  height: 30px !important;
  top: 0px !important;
}

.clearable {
	padding-left: 8px !important;
}

.multiselect__select .open-indicator {
  border-color: rgba(60, 60, 60, .5);
  border-style: solid;
  border-width: 3px 3px 0 0;
  content: "";
  display: inline-block;
  height: 10px;
  width: 10px;
  vertical-align: text-top;
  transform: rotate(133deg);
  box-sizing: inherit;
}

.multiselect__select::before {
  display: none !important;
}

.multiselect__option {
  width: 100%;
  overflow: hidden;
  white-space: break-spaces;
}

.telao .multiselect__tags {
  border-radius: 0 !important;
  border: 0 !important;
  padding: 8px 40px 0 8px;
}

.telao .multiselect__tag {
  margin-bottom: 0 !important;
  background-color: #f0f0f0;
  color: #333;
}

.telao .multiselect__tag-icon:focus,
.telao .multiselect__tag-icon:hover {
  background-color: #f0f0f0;
  color: #333;
}


.telao .multiselect__tags,
.telao .multiselect__single {
  padding-left: 0;
  padding-right: 0;
}

.telao .multiselect__single {
  margin-bottom: 0;
}

.telao.multiselect,
.telao .multiselect__tags {
  min-height: unset !important;
}

body .multiselect__input {
  background-color: transparent !important;
  padding-left: 0;
}

.multiselect__option--highlight,
.multiselect__option--highlight::after {
  background: #5897fb !important;
}

.multiselect__option {
  min-height: unset;
  line-height: 1.5;
  padding: 3px 20px;
}

.multiselect__tag-icon:after {
  color: #333 !important;
}

.multiselect__tag-icon:hover:after,
.multiselect__tag-icon:focus:after {
  color: #333 !important;
}

.multiselect__option:after {
	line-height: 27px !important;
}

.multiselect-wrapper {
  position: relative;
  display: inline-block;
  width: 100%;
}

.multiselect__clear {
  position: absolute;
  left: 8px;
  top: 63%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: auto;
  background-color: transparent;
  user-select: none;
  font-style: normal;
}

.multiselect__clear-icon {
  font-size: 21px;
  font-weight: bold;
  font-style: normal !important;
  line-height: 1;
  color: rgb(191, 9, 9) !important;
  display: block;
}

.multiselect__clear:hover .multiselect__clear-icon {
  color: rgb(191, 9, 9) !important;
}

.telao .multiselect__clear {
  left: -9px;
}

</style>